import React, { Component } from 'react'
import { Tabs } from 'antd';
// import img1 from '../../static/images/case-banner.png'
import case1 from '../../static/images/case-1.png'
// import product2 from '../../static/images/product-2.png'
import product3 from '../../static/images/product-3.png'
// import product4 from '../../static/images/product-4.png'
// import product5 from '../../static/images/product-5.png'
// import product6 from '../../static/images/product-6.png'
// import product7 from '../../static/images/product-7.png'
// import product8 from '../../static/images/product-8.png'


import './index.less';
// const { TabPane } = Tabs;
class Cases extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
            { img: case1 },
        ],
    }
     componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'cases-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                <iframe
                    title="cases-static"
                    src={`${process.env.PUBLIC_URL}/static/cases/cases.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="case-container">
            //     <div className="top-home-carousel">
            //         <Carousel autoplay>
            //             <div><img className="carousel-img" src={img1} alt="" /></div>
            //             {/* <div><img className="carousel-img" src={img1} alt="" /></div>
            //             <div><img className="carousel-img" src={img1} alt="" /></div>
            //             <div><img className="carousel-img" src={img1} alt="" /></div> */}
            //         </Carousel>
            //     </div>
            //     <div className="common-block-home">
            //         <Tabs className="common-block-case-tabs" tabPosition="top">
            //             <TabPane tab="连锁便利" key="1">
            //                 <div className="common-block-case">
            //                     {
            //                         partnerList && partnerList.map((item,index) => (
            //                             <div className="case-detail-block" key={index}>
            //                                 <img className="case-detail-img" src={item.img} alt="" />
            //                                 <div className="case-detail-tips">2天时间的改造，【兴兰便利】24小时智能店的生意火爆了整个社区.....</div>
            //                             </div>
                                        
            //                         ))
            //                     }

            //                 </div>
            //             </TabPane>
            //             <TabPane tab="无人零售" key="2">
            //                 <div className="common-block-case">
            //                     {
            //                         partnerList && partnerList.map((item,index) => (
            //                             <div className="case-detail-block" key={index}>
            //                                 <img className="case-detail-img" src={item.img} alt="" />
            //                                 <div className="case-detail-tips">2天时间的改造，【兴兰便利】24小时智能店的生意火爆了整个社区.....</div>
            //                             </div>

            //                         ))
            //                     }

            //                 </div>
            //             </TabPane>
            //             <TabPane tab="农贸市场" key="3">
            //                 <div className="common-block-case">
            //                     {
            //                         partnerList && partnerList.map((item, index) => (
            //                             <div className="case-detail-block" key={index}>
            //                                 <img className="case-detail-img" src={item.img} alt="" />
            //                                 <div className="case-detail-tips">2天时间的改造，【兴兰便利】24小时智能店的生意火爆了整个社区.....</div>
            //                             </div>

            //                         ))
            //                     }

            //                 </div>
            //             </TabPane>
            //         </Tabs>
            //     </div>
    
            // </div >
        )
    }
}


export default Cases